import { Component, OnInit, Injector, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { WorkOrderProgramGridTemplate } from './work-order-program-grid.template';
import { WorkOrdersService } from '../../work-orders.service';

@Component({
  selector: 'work-order-program-dialog',
  templateUrl: './work-order-program-dialog.component.html',
})
export class WorkOrderProgramDialogComponent implements OnInit {
  data: any = {};
  gridTemplate: any;
  workOrdersService: WorkOrdersService;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<WorkOrderProgramDialogComponent>,
    injector: Injector
  ) {
    this.data = data;
    this.gridTemplate = new WorkOrderProgramGridTemplate(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  onYesClick(): any {
    const ids: any[] = [];
    this.gridTemplate.selectedRows.forEach(element => {
      ids.push(element.dataItem.Id);
    });
    this.dialogRef.close(ids);
  }

  onNoClick(): void {
    this.workOrdersService.setIsReports = false;
    this.dialogRef.close();
  }

  isDisabled() {
    return this.gridTemplate.selectedRows.length === 0;
  }
}
